var React = require("react");
const createReactClass = require("create-react-class");

var form = require("../../deploynaut/js/Form.jsx");

var ProfileRegistration = createReactClass({

	componentDidMount: function () {
		document.getElementById('FirstName').focus();
	},

	render: function () {
		var details = this.props.model.Details;
		var securityID = this.props.model.InitialSecurityID;

		var password = (
			<div>
				<div className="form-group">
					<label htmlFor="Password">Password</label>
					<form.Password name="Password" required validationError="Please enter a valid password" />
					<div className="help-text">
						A password must have at least 10 characters. It must contain
						a mix of lowercase letters, uppercase letters, numbers, and symbols.
					</div>
				</div>
				<div className="form-group">
					<label htmlFor="Password_confirm">Confirm password</label>
					<form.Password
						name="Password_confirm"
						validations='equalsField|"Password"|"Password_confirm"'
						required
						validationError="Passwords must match"
					/>
				</div>
			</div>
		);
		var partialMessage = (
			<div className="alert alert-warning">
				Some of your profile details seem to be missing. Please complete the registration before continuing.
			</div>
		);
		const mobilePhoneProps = {};
		if (this.props.model.MobilePhoneRequired) {
			mobilePhoneProps.required = 'required';
			mobilePhoneProps.validationError = 'You must supply a phone number to authorise stack changes';
		}
		return (
			<div>
				{this.props.model.Partial ? partialMessage : <div />}
				<form.Form
					ref="registrationForm"
					url={this.props.model.DetailsRegisterUrl}
					securityID={securityID}
					buttonTitle="Register"
					buttonSubmittingTitle="Registering"
				>
					<div className="form-group">
						<label htmlFor="FirstName">First name</label>
						<form.Input
							name="FirstName"
							value={details.FirstName}
							required
							validationError="Please enter your first name"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="Surname">Surname</label>
						<form.Input
							name="Surname"
							value={details.Surname}
							required
							validationError="Please enter your surname"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="Email">Email</label>
						<form.Input
							name="Email"
							value={details.Email}
							disabled
						/>
					</div>
					<div className="form-group">
						<label htmlFor="Username">Username</label>
						<form.Input
							name="Username"
							value={details.Username}
							required
							validationError="Please choose a username"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="MobileNumber">Mobile phone</label>
						<form.Input
							name="MobileNumber"
							value={this.props.model.Details.MobileNumber}
							{...mobilePhoneProps}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="Timezone">Dashboard Timezone</label>
						<form.Select
							name="Timezone"
							required
							validationError="Please choose a timezone"
							options={this.props.model.Timezones}
							value={this.props.model.Details.Timezone ? this.props.model.Details.Timezone : this.props.model.DefaultTimezone}
						/>
					</div>
					{this.props.model.Partial ? <div /> : password}
				</form.Form>
			</div>
		);
	}
});

module.exports = ProfileRegistration;
